import { defaultFill } from '../../utils/constants';
var muiChatOutline16 = {
    paths: [
        {
            path: 'M11.7927161,7.9219496 L12.1559148,7.76984221 C13.2631358,7.30613883 14,6.22030968 14,5 C14,3.34618032 12.6557554,2 11.0033142,2 L4.99668583,2 C3.34461797,2 2,3.3446759 2,5 C2,6.65381968 3.34424456,8 4.99668583,8 L8.4603598,8 L10.0875127,9.62715293 L11.7927161,7.9219496 Z M10.7923208,11.750772 C10.403066,12.1400268 9.76465983,12.1327272 9.37955379,11.7476211 L7.63193268,10 L4.99668583,10 C2.23709245,10 0,7.75580481 0,5 C0,2.23857625 2.24157855,0 4.99668583,0 L11.0033142,0 C13.7629076,0 16,2.24419519 16,5 C16,7.07793887 14.7307318,8.85982134 12.9284965,9.61459625 L10.7923208,11.750772 Z',
            fill: defaultFill,
        },
    ],
    title: 'Chat',
    width: 16,
    height: 12,
};
var muiChatOutline24 = {
    paths: [
        {
            path: 'M17.7852545,12.8497323 L18.2304635,12.7001679 C20.4468246,11.9555994 21.9736901,9.86819881 21.9736901,7.49177815 C21.9736901,4.46362051 19.5136122,2 16.4868777,2 L7.48681235,2 C4.46094912,2 2,4.46105515 2,7.49177815 C2,10.5199358 4.4600779,12.9835563 7.48681235,12.9835563 L12.8323457,12.9835563 L15.2418881,15.3930987 L17.7852545,12.8497323 Z M15.9553488,17.5080651 C15.5613153,17.9020986 14.9296822,17.9093199 14.5349437,17.5145814 L12.0039186,14.9835563 L7.48681235,14.9835563 C3.35196007,14.9835563 0,11.6209538 0,7.49177815 C0,3.35418333 3.35868184,0 7.48681235,0 L16.4868777,0 C20.62173,0 23.9736901,3.3626025 23.9736901,7.49177815 C23.9736901,10.7956688 21.8321596,13.600048 18.8673682,14.5960457 L15.9553488,17.5080651 Z',
            fill: defaultFill,
        },
    ],
    title: 'Chat',
    width: 24,
    height: 18,
};
var muiChatOutline = {
    base: muiChatOutline16,
    smIcon: muiChatOutline16,
    lgIcon: muiChatOutline24,
};
export { muiChatOutline };
//# sourceMappingURL=chatOutline.js.map